import Req from '../../req'
const actions = {
    goods: function (store, [cb]) {
        let data = {
            max: 4,
            uid: store.rootState.user.uid,
        }
        Req.speedTelescope.goods(data, cb);
    },
    unifiedOrder: function (store, [gid, cb]) {
        let data = {
            // pid:peerid,
            appid: "wx653b5449fa8d8668",
            ref_uid: "",
            trade_type: "NATIVE", //二维码方式
            extattr: "",
            uid: store.rootState.user.uid,
            gid: gid,
        }
        Req.speedTelescope.unifiedOrder(data, cb);
    },
    orderQuery: function (store, [out_trade_no, cb]) {
        let data = {
            out_trade_no: out_trade_no,
        }
        Req.speedTelescope.orderQuery(data, cb);
    },

}
export default {
    namespaced: false,
    actions
}